import React from 'react';

const Problem: React.FC = () => (
  <section id="problem">
    <div className="problem-inner">
      <p className="eyebrow problem-eyebrow reveal">The Gap</p>
      <blockquote className="problem-quote reveal reveal-delay-1">
        &ldquo;I&apos;ll learn more about my deen when life slows down.&rdquo;
      </blockquote>
      <div className="problem-rule reveal reveal-delay-2" />
      <p className="problem-sub reveal reveal-delay-2">It never slows down.</p>
      <p className="problem-body reveal reveal-delay-3">
        Most Muslims don&apos;t need another 90-minute lecture saved for &ldquo;later.&rdquo; They need five focused minutes today on the question
        they&apos;re actually carrying right now. Niyyah is built for that life.
      </p>
    </div>
  </section>
);

export default Problem;
